import { Component, Output, EventEmitter, SimpleChanges, AfterViewChecked } from '@angular/core';
import { UtilService, DialogService, PagedResult, PagedSearch, DatagridService } from '../../shared/index'; //app/shared/index barrel;
import { ProfileSearchService, ProfileSearchParams, ProfileSearchResult } from '../search/index';
import { NumberValueAccessor, CreateNumberValueAccessorProvider } from '../../shared/widgets/value-accessors/number-value-accessor';
import { ProfileService } from '../shared/profile.service';
import { ProfileRead } from '../shared/profile-read.model';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'wl-profile-lookup',
  templateUrl: 'profile-lookup.component.html',
  styleUrls: ['profile-lookup.component.css'],
  providers: [ProfileSearchService, ProfileService, CreateNumberValueAccessorProvider(ProfileLookupComponent)],
    standalone: false
})
export class ProfileLookupComponent extends NumberValueAccessor implements AfterViewChecked {
  @Output() onProfileChanged = new EventEmitter<ProfileRead>();

  public _utilService: UtilService;
  public _profileSearchService: ProfileSearchService;
  public _dataGridService: DatagridService;
  public _dialogService: DialogService;
  public _profileService: ProfileService;
  public _translateService: TranslateService;
  public _lastValue: number;

  public searchHasResults: boolean;
  public profileSearchParams: ProfileSearchParams;
  public profileResults: ProfileSearchResult;
  public errorMessage: string;
  public searchPerformed: boolean;
  public isSearching: boolean;
  public profileName: string;
  public displayName: string;
  public showModal = false;

  public selectedProfile: ProfileRead;

  public constructor(
    utilService: UtilService,
    translateService: TranslateService,
    profileSearchService: ProfileSearchService,
    dataGridService: DatagridService,
    dialogService: DialogService,
    profileService: ProfileService
  ) {
    super();
    this._utilService = utilService;
    this._translateService = translateService;
    this._profileSearchService = profileSearchService;
    this._dataGridService = dataGridService;
    this._dialogService = dialogService;
    this._profileService = profileService;

    this.profileSearchParams = new ProfileSearchParams();
    this.profileSearchParams.Keyword = '';
    this.profileResults = new ProfileSearchResult();
    this.searchHasResults = false;
    this.searchPerformed = false;
    this.isSearching = false;
    this.profileName = '';
    this.displayName = '';
    this._lastValue = -1;
    this.selectedProfile = new ProfileRead();
  }

  public showSearch = (): void => {
    this.showModal = true;
  };

  public hideSearch = (): void => {
    this.showModal = false;
  };

  public executeSearch = (event: any): void => {
    if (this._utilService.isNotNullEmptyOrWhitespace(this.profileSearchParams.Keyword)) {
      this._dataGridService.mapDatagridPagingToPagedSearch(event, this.profileSearchParams);

      //this._dialogService.showWaitIndicator();
      this.isSearching = true;

      this._profileSearchService.search(this.profileSearchParams).then(
        (data: any) => {
          this.profileResults = data;
          //update the search params based on current page number etc
          this._dataGridService.mapPagedResultsToPagedSearch(data, this.profileSearchParams);
          if (data.TotalCount > 0) {
            this.searchHasResults = true;
          } else {
            this.searchHasResults = false;
          }
          this.searchPerformed = true;
          this.isSearching = false;
          //this._dialogService.closeWaitIndicator();
          //setTimeout(() => {
          //    this.isSearching = false;
          //}, 500);
        },
        (error: any) => {
          this.errorMessage = <any>error;
          this.searchPerformed = true;
          this.isSearching = false;
          //this._dialogService.closeWaitIndicator();
          //setTimeout(() => {
          //    this.isSearching = false;
          //}, 500);
        }
      );
    }
  };

  public selectProfile = (profileId: number): void => {
    this.value = profileId;
    this.getProfile();
    this.hideSearch();
  };

  public getProfile = (): void => {
    if (this._utilService.isNotNullAndGreaterThanZero(this.value)) {
      if (this._lastValue != this.value) {
        this._lastValue = this.value;

        this._profileService.getProfile(this.value).then((data: ProfileRead) => {
          this.profileName = data.ReportName;
          this.displayName = data.ReportName + ' (' + this.value.toString() + ')';
          this.selectedProfile = data;
          this.emitOutputObject();
        });
      }
    } else {
      this._translateService
        .get('common.none')
        .toPromise()
        .then((result: string) => {
          this.profileName = result;
          this.displayName = result + ' (0)';
          this.selectedProfile = new ProfileRead();
          this.emitOutputObject();
        });
    }
  };

  ngAfterViewChecked() {
    this.getProfile();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getProfile();
  }
  modelChange() {
    this.emitOutputObject();
  }

  emitOutputObject = (): void => {
    this.onProfileChanged.emit(this.selectedProfile);
  };
}
